import { useEffect, useMemo, useState } from 'react'
import { MacrosDistribution, MealOfDayDivision, SimulationProfile } from '@/api/types'

import { defaultUserProfile } from '../defaultUserProfile'
import { useQuery } from '@tanstack/react-query'
import { simulationProfileQuery } from '@/api/mealPlan'
import { getSelectedMealsFromMealDivisions } from '@/utils'
import { use } from 'i18next'

export default function useSimulationProfile(
  energyDistribution: MacrosDistribution,
  defaultMealOfDayDivisions: MealOfDayDivision[],
) {
  const selectedMeals = useMemo(
    () => getSelectedMealsFromMealDivisions(defaultMealOfDayDivisions),
    [defaultMealOfDayDivisions],
  )

  const [simulationProfile, setSimulationProfile] = useState<SimulationProfile>({
    userProfile: {
      ...defaultUserProfile,
      userEnergyDistribution: energyDistribution,
      mealOfDayDivisions: defaultMealOfDayDivisions,
      household: {
        ...defaultUserProfile.household,
        selectedMeals,
        noOfMealsPerDay: selectedMeals.length,
      },
    },
  })
  const [profileId, setProfileId] = useState<number | undefined>(undefined)

  const { data: profile, error, isLoading } = useQuery(simulationProfileQuery(profileId))

  useEffect(() => {
    if (profile) {
      setSimulationProfile(profile)
    }
  }, [profile])

  function setSimulationProfileHandler(profile: SimulationProfile) {
    if (!profile) {
      setSimulationProfile({
        userProfile: {
          ...defaultUserProfile,
          userEnergyDistribution: energyDistribution,
          mealOfDayDivisions: defaultMealOfDayDivisions,
        },
      })
    } else if (profile.id && !profile.userProfile) {
      setProfileId(profile.id)
    } else {
      setSimulationProfile(profile)
    }
  }

  return { simulationProfile, setSimulationProfile: setSimulationProfileHandler }
}
